import axios from 'axios';
const ASSET_CONTAINER_ID = 'mf-ui-assets';
export const getAssetContainer = () => {
    return document.getElementById(ASSET_CONTAINER_ID);
};
export const assetLoaded = src => {
    return document.getElementById(src);
};
export class SpriteSheetLoader {
    constructor() {
        if (!getAssetContainer()) {
            this.createAssetContainer();
        }
    }
    createAssetContainer() {
        const element = document.createElement('DIV');
        element.setAttribute('id', ASSET_CONTAINER_ID);
        element.setAttribute('style', 'position:absolute;height:0;visibility: hidden;overflow: hidden;');
        document.body.appendChild(element);
    }
    load(src) {
        if (!assetLoaded(src)) {
            this.loadAsset(src).then(({ data }) => {
                const wrapper = document.createElement('div');
                wrapper.setAttribute('id', src);
                wrapper.innerHTML = data.replace(new RegExp('script', 'g'), 'scrpt');
                const container = getAssetContainer();
                if (container !== null && wrapper.firstChild !== null) {
                    container.appendChild(wrapper.firstChild);
                }
            });
        }
    }
    loadAsset(src) {
        return axios.get(src);
    }
}
//# sourceMappingURL=SVGSpritesheetLoader.js.map